import { cloneDeep } from 'lodash';
import { useCallback } from 'react';
import { ISchedulingFeatureSettings } from 'types/SchedulingSettings';
import useMemberFeatureSettingsUpdate from '../member/useMemberFeatureSettingsUpdate';
import useMemberSettings from '../member/useMemberSettings';

export default function useSchedulingSettingsUpdate() {
  const memberSettings = useMemberSettings();
  const updateFeatureSettings = useMemberFeatureSettingsUpdate();

  return useCallback(
    <K extends keyof ISchedulingFeatureSettings>(
      keysAndPayloads: { key: K; payload: ISchedulingFeatureSettings[K] }[]
    ) => {
      const cloned = cloneDeep(memberSettings?.web?.features?.scheduling);

      const mapped = keysAndPayloads.reduce(
        (acc, cur) => ({
          ...acc,
          [cur.key]: cur.payload,
        }),
        cloned
      );

      return updateFeatureSettings('scheduling', mapped);
    },
    [memberSettings, updateFeatureSettings]
  );
}
